import { SettingKey } from '@frontend/setting/types';
import { MobileWizardStateRecord } from '@frontend/wizard/mobile';
import { useMemo } from 'react';

export interface WizardSettings {
    transactionWorkflowId: string | undefined;
    dropOffPackageWorkflowId: string | undefined;
    pickUpPackageWorkflowId: string | undefined;
    /**
     * Generic accessor for any other setting key that we don't want to expose
     * as a named field. Returns the raw setting `value` (or `undefined`).
     */
    get: (key: SettingKey) => string | undefined;
}

/**
 * Typed accessor for functionality settings on the current wizard store. This
 * replaces the repeated `store.functionalitySettings.find(...)?.value as string | undefined`
 * pattern scattered across wizard controllers.
 */
export const useWizardSettings = (store: MobileWizardStateRecord | null | undefined): WizardSettings => {
    return useMemo(() => {
        const settings = store?.functionalitySettings ?? [];
        const get = (key: SettingKey): string | undefined => {
            const value = settings.find((s) => s.key === key)?.value;
            return typeof value === 'string' ? value : undefined;
        };
        return {
            transactionWorkflowId: get(SettingKey.TRANSACTION_WORKFLOW_ID),
            dropOffPackageWorkflowId: get(SettingKey.DROP_OFF_PACKAGE_WORKFLOW_ID),
            pickUpPackageWorkflowId: get(SettingKey.PICK_UP_PACKAGE_WORKFLOW_ID),
            get
        };
    }, [store?.functionalitySettings]);
};
